import { Component, OnInit, AfterViewInit } from '@angular/core';
import { SubmittPropertyModel, Image } from 'src/model/submittProperty/submitProperty';
import { SubmitPropertyService } from 'src/services/SubmitProperty';
import { ToasterService } from '../_services/toaster.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '../_services/loader.service';
import { Title } from '@angular/platform-browser';
import { NiceScrollService } from '../_services/nice-scroll.service';
import { ViewChild } from '@angular/core';
import { QuillEditorComponent } from 'ngx-quill';
declare var jquery: any;
declare var $: any;


@Component({
    selector: 'app-submit-property',
    templateUrl: './submit-property.component.html',
    styleUrls: ['./submit-property.component.css'],
    providers: [SubmittPropertyModel, Image],
    standalone: false
})
export class SubmitPropertyComponent implements OnInit {

 @ViewChild('propertyDescriptionRef', { static: true })
  quillEditorComponent!: QuillEditorComponent;
  PropertyId: any;
  Title: string;
  Description: string;
  PurposeId: any;
  TypeId: any;
  Price: any;
  BedRoomId: any;
  BathRoomId: any;
  Area: any;
  AreaUnitId: any;
  CityId: any;
  LocationId: any;
  fullName: string;
  phoneNumber: string;
  emailAddress: string;
  OtherFeatures: any;
  PurposeDropdown: Array<any> = [];
  TypesDropdown: Array<any> = [];
  BedRoomsDropdownData: Array<any> = [];
  BathRoomsDropdown: Array<any> = [];
  AreaUnitsDropdown: Array<any> = [];
  CitiesDropdown: Array<any> = [];
  LocationsDropdown: Array<any> = [];
  files: File[] = [];
  formSubmitted = false;
  showFields = false;

  urls = new Array<string>();
  imageUrls = new Array<string>();
  constructor(private submitPropertyService: SubmitPropertyService,
              private toastr: ToasterService,
              private activatedroute: ActivatedRoute,
              private loaderService: LoaderService,
              private router: Router,
              private title: Title,
              private niceScroll: NiceScrollService

            ) {
              niceScroll.scrollToTop();
              this.PropertyId = 0;
            }

  Id: any;
  ngOnInit() {
    this.FillDropdownAndCreateCheckboxes();
    this.CheckEitherThePageIsForUpdate();
    this.title.setTitle('Submit Property | pakmatti.com');
  }

  CheckEitherThePageIsForUpdate() {
    this.activatedroute.paramMap.subscribe(params => {
      this.Id = params.get('id');
      if (this.Id !== null) {
        this.loaderService.showLoader();
        this.submitPropertyService.GetPropertyDetailsByID(this.Id).subscribe(data => {
          // tslint:disable-next-line: triple-equals
          if (data.PropertyId == this.Id) {
            this.FillTheModels(data);
          } else {
            this.toastr.Warning('Sorry! We conuldn\'t find any property associated like this with your account');
          }
          this.loaderService.hideLoader();
          return;
        });
      } else {
        // tslint:disable-next-line: prefer-const
        let applicationUser = JSON.parse(localStorage.getItem('currentUser'));
        this.fullName = applicationUser.FirstName + ' ' + applicationUser.LastName;
        this.emailAddress = applicationUser.EmailAddress;
        this.phoneNumber = applicationUser.PhoneNumber;
      }
    });
  }

  FillTheModels(data: any) {
    this.showFields = true;
    this.PropertyId = data.PropertyId;
    this.Title = data.Title;
    this.PurposeId = data.PurposeId;
    this.TypeId = data.TypeId;
    this.Price = data.Price;
    this.BedRoomId = data.BedRoomId;
    this.BathRoomId = data.BathRoomId;
    this.Area = data.Area;
    this.AreaUnitId = data.AreaUnitId;
    this.Description = data.Description;
    this.CityId = data.CityId;
    this.changeCity();
    this.fullName = data.FullName;
    this.emailAddress = data.EmailAddress;
    this.phoneNumber = data.PhoneNumber;
    this.LocationId = data.LocationId;
    this.setOtherFeatures(data.OtherFeaturesIds);

    for (let imageIndex = 0; imageIndex < data.Images.length; imageIndex++) {
      try {
        const byteCharacters = atob(data.Images[imageIndex]);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        // tslint:disable-next-line: prefer-const
        let file = new File([byteArray], data.ImagesPathArrayList[imageIndex], { type: 'image/jpeg' });
        this.files.push(file);
      } catch (error) {
        console.log(error);
      }
    }
    this.readImages();
    this.changePropertyType();

    setTimeout(() => {
       $('.custom-quill .ql-editor p').html(data.Description)
    }, 1000);
  }

  FillDropdownAndCreateCheckboxes() {
    this.submitPropertyService.getPropertyDetails().subscribe(data => {
      this.PurposeDropdown = data.Purposes;
      this.TypesDropdown = data.Types;
      this.BedRoomsDropdownData = data.BedRooms;
      this.BathRoomsDropdown = data.BathRooms;
      this.AreaUnitsDropdown = data.AreaUnits;
      this.CitiesDropdown = data.Cities;
      this.OtherFeatures = data.OtherFeatures;
    });
  }

  setOtherFeatures(otherFeaturesIds: any) {
    const otherFeatures = this.OtherFeatures;
    $(otherFeaturesIds).each(function () {
      const id = this;
      $(otherFeatures).each(function () {
        // tslint:disable-next-line: triple-equals
        if (this.Id == id) {
          this.IsChecked = true;
        }
      });
    });
  }

  Submit(): void {
    $('body').addClass('loading').loader('show', { overlay: true });
debugger;
var plainText  = this.quillEditorComponent.quillEditor.getText().replace(/\s{2,}/g, ' ');
    plainText = plainText.replace(/[\r\n]+/g, '');
    const formData = new FormData();
    formData.append('PropertyId', this.PropertyId);
    formData.append('Title', this.Title);
    formData.append('Description', this.Description);
    formData.append('PlainTextDescription',plainText);
    formData.append('PurposeId', this.PurposeId);
    formData.append('TypeId', this.TypeId);
    formData.append('Price', this.Price);
    formData.append('BedRoomId', this.BedRoomId);
    formData.append('BathRoomId', this.BathRoomId);
    formData.append('Area', this.Area);
    formData.append('AreaUnitId', this.AreaUnitId);
    formData.append('CityId', this.CityId);
    formData.append('LocationId', this.LocationId);
    formData.append('OtherFeatures', JSON.stringify(this.OtherFeatures));
    formData.append('FullName', this.fullName);
    formData.append('EmailAddress', this.emailAddress);
    formData.append('PhoneNumber', this.phoneNumber);
    if (this.files !== null || this.files !== undefined) {
      // tslint:disable-next-line: prefer-for-of
      for (let index = 0; index < this.files.length; index++) {
        // let index of this.Images
        formData.append('file', this.files[index]);
      }
    }
    this.formSubmitted = true;
    this.submitPropertyService.SubmitProperty(formData).subscribe(d => {
      $('body').removeClass('loading').loader('hide');
      this.toastr.Success('Your property is saved successfully and sent Admin for approval.');
      this.router.navigate(['/account/properties']);
    });
  }

  changeCity(): void {
    this.LocationId = '';
    this.submitPropertyService.getLocationsByCityId(this.CityId).subscribe(data => {
      this.LocationsDropdown = data;
    });
  }

  changePropertyType(): void{
    console.log(this.TypeId)

    if(this.TypeId === 7 ||this.TypeId === 8 || this.TypeId ===9 || this.TypeId ===10|| this.TypeId ===11|| this.TypeId ===12 || this.TypeId ===19){
      this.showFields = false;
    }else{
      this.showFields = true;
    }
  }

  onRemove(fileIndex) {
    const files: File[] = [];
    // tslint:disable-next-line: prefer-for-of
    for (let index = 0; index < this.files.length; index++) {
      // tslint:disable-next-line: triple-
      // tslint:disable-next-line: triple-equals
      if (this.files[index] != this.files[fileIndex]) {
        files.push(this.files[index]);
      }
    }

    this.imageUrls = [];

    // tslint:disable-next-line: prefer-for-of
    for (let index = 0; index < this.urls.length; index++) {
      // tslint:disable-next-line: triple-
      // tslint:disable-next-line: triple-equals
      if (index != fileIndex) {
        this.imageUrls.push(this.urls[index]);
      }
    }
    this.urls = this.imageUrls;
    this.files = files;
  }

  clearAllField(): void {
    this.Title = ' ';
    this.Description = ' ';
    this.PurposeId = null;
    this.TypeId = null;
    this.Price = ' ';
    this.BedRoomId = null;
    this.BathRoomId = null;
    this.Area = ' ';
    this.AreaUnitId = null;
    this.CityId = null;
    this.LocationId = null;
    this.files = [];
    // tslint:disable-next-line: prefer-for-of
    for (let index = 0; index < this.OtherFeatures.length; index++) {
      this.OtherFeatures[index].IsChecked = false;
    }

  }

  addImage() {
    $('#image-upload').trigger('click');
  }

  uploadImages(upload: any) {
    let index = 0;
    // tslint:disable-next-line: prefer-const
    let files: File[] = [];
    this.urls = [];
    for (let filesCount = this.files.length; filesCount < 16 && index < upload.target.files.length; filesCount++) {
      let isAlreadyExists = false;
      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < this.files.length; i++) {
        // tslint:disable-next-line: triple-equals
        if (this.files[i].name == upload.target.files[index].name && this.files[i].size == upload.target.files[index].size) {
          isAlreadyExists = true;
        }
      }
      if (!isAlreadyExists) {
        files.push(upload.target.files[index]);
      }
      index += 1;
    }

    files.forEach(file => {
      this.files.push(file);
    });

    if (this.files) {
      for (const file of this.files) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.urls.push(e.target.result);
        };
        reader.readAsDataURL(file);
      }
    }
    upload.target.value = '';
  }

  readImages() {
    // tslint:disable-next-line: prefer-const
    this.urls = [];
    if (this.files) {
      for (const file of this.files) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.urls.push(e.target.result);
        };
        reader.readAsDataURL(file);
      }
    }
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

editorModules = {
  toolbar: [
    ['bold', 'italic', 'underline'],
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    ['link'],
    [{ 'header': [1, 2, 3, false] }],
    ['clean']
  ]
};


}
